import React from 'react'

const NotFound = () => (
  <div className="not-found">
    <h1>404 Not Found</h1>
    <p>These are not the droids that you are looking for.</p>
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/common/ui/NotFound.jsx